import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const useFetchRecurringPayments = (userObj,orgId) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const token=getTokenfromUserObj();
  useEffect(() => {
    const fetchData = async (userObj,orgId) => {
      console.log(userObj,orgId);
      try {
        let query;
        if(userObj.userType==="A")query=`${app.URL}/recurrpayment/view`;
        else if(userObj.userType==="O")query=`${app.URL}/recurrpayment/view?organizationId=${orgId}`;
        console.log(query)
        const res = await axios.get(query,{headers:{auth:token}});
        console.log(res);
        setResponse(res.data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchData(userObj,orgId);
  }, []);

  return { loading, response, error };
};

export default useFetchRecurringPayments;
